import { render, staticRenderFns } from "./inboxargs.vue?vue&type=template&id=3756a354&"
import script from "./inboxargs.vue?vue&type=script&lang=js&"
export * from "./inboxargs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports